import * as React from 'react';
import { flow } from 'lodash';
import { IStore } from '../../../../redux/IStore';
import { connect } from 'react-redux';
import { IAuthState } from '../../../../services/auth/models';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IMTACancellationOptions } from '../../../../data/api/models';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';

interface IAccountSummaryProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    push(path: string);
  };
}

export interface ICustomerMTAOptions {
  email_address: {
    enabled: boolean;
  };
  phone_number: {
    enabled: boolean;
  };
  customer_address: {
    enabled: boolean;
  };
  customer_name: {
    enabled: boolean,
    duration_in_hours_from_issue: number,
  };
  travellers_names: {
    enabled: boolean,
    duration_in_hours_from_issue: number,
  };
  additional_travellers: {
    enabled: boolean,
  };
  change_medical: {
    enabled: boolean,
  };
  additional_options: {
    enabled: boolean,
  };
  change_region: {
    enabled: boolean,
  };
  change_destination: {
    enabled: boolean,
  };
  change_tier: {
    enabled: boolean,
  };
  change_trip_type: {
    enabled: boolean,
  };
  change_trip_date: {
    enabled: boolean,
  };
  change_start_date: {
    enabled: boolean,
  };
  allow_cancel_policy: {
    enabled: boolean,
  };
  allow_cancel_renewal: {
    enabled: boolean,
  };
  allow_remove_traveller: {
    enabled: boolean,
  };
  allow_option_removal: {
    enabled: boolean,
  };
  cancellation: IMTACancellationOptions
  change_max_trip_duration: {
    enabled: boolean,
  };
  other: {
    enable_contact_us: boolean,
    carousel_animation_speed: number
    opening_hours: {
      from: string,
      to: string,
    }
  }

}

class MakeAChange extends React.Component<IAccountSummaryProps, any> {

  constructor(props) {
    super(props);
    if (props.auth.customer.activePolicies.length === 1) {
      props.actions.push(`/account/make-a-change/selection/${props.auth.customer.activePolicies[0].id}`);
    } else {
      props.actions.push('/account/summary')
    }
  }

  public render() {
    return null;
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
      },
    }),
  ),
])(MakeAChange);
